import apiService from './api';

const externalMemberService = {
  async list(params = {}) {
    return apiService.get('/external-members', { params });
  },

  async getById(id) {
    return apiService.get(`/external-members/${id}`);
  },

  async create(payload) {
    return apiService.post('/external-members', payload);
  },

  async update(id, payload) {
    return apiService.put(`/external-members/${id}`, payload);
  },

  async remove(id) {
    return apiService.delete(`/external-members/${id}`);
  }
};

export default externalMemberService;

